module.exports = __webpack_public_path__ + "static/media/technology_funds.e8b2752a.svg";